import React from 'react';
import { Button, Form, Checkbox } from 'semantic-ui-react';
import styled from "styled-components";
import { ErrorMessage } from "formik";

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class ConsentForm extends React.Component<any, any> {

    prev = (e: any) => {
        e.preventDefault();
        this.props.prevStep();
    }

    next = (e: any) => {
        e.preventDefault();
        this.props.gaEvent('event', 'AcceptTerms', 'Next', 'Boots', this.props.isValid);
        this.props.nextStep(this.props);
    }

    render() {
        return (
            <React.Fragment>
                <Form.Group grouped>

                    <label>
                        Please confirm that you agree to the following in order for us to continue with your claim.
                    </label>

                    <div className="ui divider"></div>
                    <Form.Field>
                        <Checkbox
                            name='stp4_consentPermission'
                            label={<label>I give consent for Pay Justice to provide Leigh Day access to this data 
                                in order to continue with the process of making a claim until the conclusion of the case when 
                                my information will be forgotten.</label>}
                            checked={this.props.values.stp4_consentPermission}
                            onChange={(e, { name, checked }) => this.props.setFieldValue(name, checked)}
                            data-testid="cf-checkbox-permission"
                            />
                        <ErrorMessage
                            name={'stp4_consentPermission'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Field>

                    <Form.Field>
                    <Checkbox
                            name='stp4_contactPermission'
                            label={<label>I accept that Pay Justice or Leigh Day may contact me regarding this claim.
                                More Information about our privacy policy can be found <a target="_blank" rel="noopener noreferrer" href="https://payjustice.co.uk/privacy-policy/">here</a>.</label>}
                            checked={this.props.values.stp4_contacttPermission}
                            onChange={(e, { name, checked }) => this.props.setFieldValue(name, checked)}
                            data-testid="cf-checkbox-permission"
                            />
                        <ErrorMessage
                            name={'stp4_contactPermission'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Field>

                    <div className="ui divider"></div>

                    <Button.Group widths="2">
                        <Button labelPosition='left' floated='left' color="grey" icon='left chevron' content='Back' onClick={this.prev} data-testid="cf-button-back" />
                        <Button labelPosition='right' floated='right' id='nextButton' color={this.props.isValid ? 'green' : 'grey'} icon='right chevron' content='Next' onClick={this.next} data-testid="cf-button-next" />
                    </Button.Group>

                </Form.Group>
            </React.Fragment>
        );
    }
}

export default ConsentForm;